import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { CompanyMetadata, type WoltUserId } from 'common/api/api-types';
import { deliveryOsGatewayApiAgent } from 'common/api/apiAgents';
import queryKeys from 'common/hooks/queryKeys';
import { decodeHttpResponse } from 'common/utils';

const fetchCompanyByUserId = ({ userId }: { userId?: WoltUserId }) =>
  userId
    ? decodeHttpResponse(
        z.array(CompanyMetadata),
        deliveryOsGatewayApiAgent.get(`/users/${userId}/companies`),
      )
    : Promise.reject(`ERROR: Failed to fetch user's companies. The user ID is falsy`);

const useCompaniesByUserId = ({ userId }: { userId?: WoltUserId }) =>
  useQuery({
    queryKey: queryKeys.forUseCompaniesByUserId({ userId }),
    queryFn: () =>
      fetchCompanyByUserId({
        userId,
      }),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: Boolean(userId),
  });

export default useCompaniesByUserId;
